module.exports = __webpack_public_path__ + "static/media/onme-logo.60580175.png";